import React from "react"

// Badge de status reutilizável do módulo de O.S.
// Apresentacional: recebe a cor (tema Bootstrap) e o rótulo já resolvidos,
// preservando o comportamento de cada tela (ListaOS usa corDoStatus + label
// PT-BR; DetalhesOS usa getStatusBadge -> { color, label }).
const StatusBadge = ({ color, label }) => (
  <span className={`badge bg-${color}`}>{label}</span>
)

export default StatusBadge
